// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wishlists_container__TzVNU {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 20px;
  background-color: #f5f5f5;
}

.Wishlists_buttonGroup__ldBeE {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
  justify-content: center;
  flex-wrap: wrap;
}

.Wishlists_createList__zpegs,
.Wishlists_createPrivateList__-dxuN {
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.Wishlists_createList__zpegs:hover,
.Wishlists_createPrivateList__-dxuN:hover {
  background-color: #0056b3;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}
.Wishlists_createList__zpegs:active,
.Wishlists_createPrivateList__-dxuN:active {
  transform: translateY(0);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.Wishlists_createList__zpegs:disabled,
.Wishlists_createPrivateList__-dxuN:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.Wishlists_backButtonWrapper__BhrAs {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto 20px;
}

.Wishlists_backButton__IK4c\\+ {
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  background-color: #6c757d;
  color: white;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: auto;
}
.Wishlists_backButton__IK4c\\+:hover {
  background-color: #5a6268;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);
}
.Wishlists_backButton__IK4c\\+:active {
  transform: translateY(0);
}

.Wishlists_content__tTy8l {
  flex: 1 1;
  width: 100%;
}

.Wishlists_grid__hkD0k {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  width: 100%;
  height: 100%;
}
@media (max-width: 600px) {
  .Wishlists_grid__hkD0k {
    grid-template-columns: 1fr;
  }
}

.Wishlists_card__xX3Kq {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 140px;
  border: 1px solid #eaeaea;
}
.Wishlists_card__xX3Kq:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.Wishlists_userName__hNF3c {
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
}

.Wishlists_wishlistName__ap95c {
  font-size: 1rem;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.Wishlists_itemCount__1qt69 {
  margin-top: auto;
  color: #007bff;
  font-size: 0.875rem;
  font-weight: 500;
}

.Wishlists_privateIcon__7Xne3 {
  position: absolute;
  top: 12px;
  right: 12px;
  font-size: 1.1rem;
  color: #666;
}

.Wishlists_row__9DIiR {
  display: flex;
  width: 100%;
  justify-content: space-between;
  word-break: break-all;
}

.Wishlists_column__uHLh1 {
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: auto;
  width: 100%;
}

.Wishlists_shareButtonColumn__TmA65 {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: auto;
}

.Wishlists_shareButtonRow__bp0Mh {
  display: flex;
  gap: 12px;
}

.Wishlists_input__xYeLQ {
  display: flex;
}

.Wishlists_selectedWishlist__snpE2 {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  min-height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
}

.Wishlists_wishlistHeader__Ya9lc {
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eaeaea;
}
.Wishlists_wishlistHeader__Ya9lc h2 {
  font-size: 1.75rem;
  color: #333;
  margin: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}
.Wishlists_wishlistHeader__Ya9lc h2 .Wishlists_privateIcon__7Xne3 {
  font-size: 1.2rem;
  color: #666;
}
.Wishlists_wishlistHeader__Ya9lc h3 {
  font-size: 1.25rem;
  color: #666;
  margin: 8px 0 0 0;
  font-weight: normal;
}

.Wishlists_wishList__yfVvy {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.Wishlists_wishItems__X-jeJ {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.Wishlists_wishItem__ssrpY {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  transition: background-color 0.2s ease;
}
.Wishlists_wishItem__ssrpY:hover {
  background: #f0f0f0;
}
.Wishlists_wishItem__ssrpY .Wishlists_wishText__oFtyh {
  flex: 1 1;
  word-break: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
}

.Wishlists_itemActions__SOhOD {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-shrink: 0;
}
@media (max-width: 768px) {
  .Wishlists_itemActions__SOhOD {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
}

.Wishlists_orderButtons__C2RR\\+ {
  display: flex;
  gap: 4px;
  align-items: center;
}
@media (max-width: 768px) {
  .Wishlists_orderButtons__C2RR\\+ {
    justify-content: flex-end;
  }
}

.Wishlists_orderButton__yT9qW {
  padding: 4px 8px;
  min-width: 36px;
  background-color: #6c757d;
}
.Wishlists_orderButton__yT9qW:hover:not(:disabled) {
  background-color: #5a6268;
}
.Wishlists_orderButton__yT9qW:disabled {
  opacity: 0.5;
}

.Wishlists_orderEditForm__MgfaC {
  display: flex;
  align-items: center;
  margin-left: 5px;
}

.Wishlists_orderInput__PHbaE {
  width: 60px;
  padding: 4px 8px;
  margin-right: 4px;
  font-size: 14px;
  border: 1px solid #ced4da;
  border-radius: 4px;
}
.Wishlists_orderInput__PHbaE:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.Wishlists_orderEditButton__fSrK4 {
  padding: 4px 8px;
  margin-right: 8px;
  font-size: 14px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
}
.Wishlists_orderEditButton__fSrK4:hover:not(:disabled) {
  background-color: #0056b3;
}
.Wishlists_orderEditButton__fSrK4:disabled {
  opacity: 0.7;
}

.Wishlists_smallButton__910or {
  padding: 4px 8px;
  margin: 0 2px;
  font-size: 14px;
  min-width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
}
.Wishlists_smallButton__910or:first-of-type {
  background-color: #28a745;
}
.Wishlists_smallButton__910or:first-of-type:hover:not(:disabled) {
  background-color: #218838;
}
.Wishlists_smallButton__910or:last-of-type {
  background-color: #dc3545;
}
.Wishlists_smallButton__910or:last-of-type:hover:not(:disabled) {
  background-color: #c82333;
}

.Wishlists_editButton__LqdA8 {
  background-color: #ffc107;
  color: #212529;
}
.Wishlists_editButton__LqdA8:hover:not(:disabled) {
  background-color: #e0a800;
}

.Wishlists_editWishForm__bJwMs {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}
.Wishlists_editWishForm__bJwMs input {
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 1rem;
  width: 100%;
}
.Wishlists_editWishForm__bJwMs input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.Wishlists_editActions__XGMWm {
  display: flex;
  gap: 8px;
}
.Wishlists_editActions__XGMWm button {
  flex: 1 1;
}
.Wishlists_editActions__XGMWm .Wishlists_cancelButton__3D0hX {
  background-color: #6c757d;
}
.Wishlists_editActions__XGMWm .Wishlists_cancelButton__3D0hX:hover:not(:disabled) {
  background-color: #5a6268;
}

.Wishlists_actionButtons__tk\\+xE {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Wishlists_addWishForm__UdbrY {
  display: flex;
  gap: 8px;
}
.Wishlists_addWishForm__UdbrY input {
  flex: 1 1;
  padding: 12px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 1rem;
}
.Wishlists_addWishForm__UdbrY input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.Wishlists_listActions__h1ZpU {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

button {
  padding: 8px 16px;
  border-radius: 6px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.2s ease;
}
button:hover:not(:disabled) {
  background-color: #0056b3;
}
button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}
button.Wishlists_deleteButton__UfvQo {
  background-color: #dc3545;
}
button.Wishlists_deleteButton__UfvQo:hover:not(:disabled) {
  background-color: #c82333;
}
button.Wishlists_shareButton__ovAMN {
  background-color: #28a745;
}
button.Wishlists_shareButton__ovAMN:hover:not(:disabled) {
  background-color: #218838;
}

@media (max-width: 768px) {
  .Wishlists_container__TzVNU {
    padding: 16px;
  }
  .Wishlists_selectedWishlist__snpE2 {
    padding: 16px;
  }
  .Wishlists_wishlistHeader__Ya9lc h2 {
    font-size: 1.5rem;
  }
  .Wishlists_wishlistHeader__Ya9lc h3 {
    font-size: 1.1rem;
  }
  .Wishlists_wishItem__ssrpY {
    flex-direction: column;
    align-items: flex-start;
  }
  .Wishlists_actionButtons__tk\\+xE {
    gap: 12px;
  }
  .Wishlists_addWishForm__UdbrY {
    flex-direction: column;
  }
  .Wishlists_addWishForm__UdbrY input {
    width: 100%;
  }
  .Wishlists_listActions__h1ZpU {
    flex-direction: column;
  }
  .Wishlists_listActions__h1ZpU button {
    width: 100%;
  }
  .Wishlists_createList__zpegs,
  .Wishlists_createPrivateList__-dxuN,
  .Wishlists_backButton__IK4c\\+ {
    font-size: 0.9rem;
    padding: 10px 16px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .Wishlists_itemActions__SOhOD {
    margin-top: 8px;
    width: 100%;
  }
  .Wishlists_editWishForm__bJwMs input {
    font-size: 0.9rem;
  }
  .Wishlists_editActions__XGMWm {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Wishists/Wishlists.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;AACF;;AAEA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,wCAAA;AACF;AACE;;EACE,yBAAA;EACA,2BAAA;EACA,yCAAA;AAEJ;AACE;;EACE,wBAAA;EACA,wCAAA;AAEJ;AACE;;EACE,yBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,iBAAA;EACA,WAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,wCAAA;EACA,WAAA;AACF;AACE;EACE,yBAAA;EACA,2BAAA;EACA,yCAAA;AACJ;AAEE;EACE,wBAAA;AAAJ;;AAIA;EACE,SAAA;EACA,WAAA;AADF;;AAIA;EACE,aAAA;EACA,4DAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;AADF;AAGE;EAPF;IAQI,0BAAA;EAAF;AACF;;AAGA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;AAAF;AAEE;EACE,2BAAA;EACA,wCAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,gBAAA;EACA,WAAA;AADF;;AAIA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;AADF;;AAIA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AADF;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,WAAA;AADF;;AAKA;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,qBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;AAFF;;AAKA;EACE,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,wCAAA;EACA,WAAA;EACA,iBAAA;EACA,cAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,oBAAA;EACA,gCAAA;AAFF;AAIE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAFJ;AAII;EACE,iBAAA;EACA,WAAA;AAFN;AAME;EACE,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,mBAAA;AAJJ;;AAQA;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AALF;;AAQA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AALF;;AAQA;EACE,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,sCAAA;AALF;AAOE;EACE,mBAAA;AALJ;AAQE;EACE,SAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;AANJ;;AAUA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,cAAA;AAPF;AASE;EANF;IAOI,sBAAA;IACA,oBAAA;IACA,WAAA;EANF;AACF;;AASA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AANF;AAQE;EALF;IAMI,yBAAA;EALF;AACF;;AAQA;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;AALF;AAOE;EACE,yBAAA;AALJ;AAQE;EACE,YAAA;AANJ;;AAUA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;AAPF;AASE;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAPJ;;AAWA;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;AARF;AAUE;EACE,yBAAA;AARJ;AAWE;EACE,YAAA;AATJ;;AAaA;EACE,gBAAA;EACA,aAAA;EACA,eAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAVF;AAYE;EACE,yBAAA;AAVJ;AAYI;EACE,yBAAA;AAVN;AAcE;EACE,yBAAA;AAZJ;AAcI;EACE,yBAAA;AAZN;;AAiBA;EACE,yBAAA;EACA,cAAA;AAdF;AAgBE;EACE,yBAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,WAAA;AAfF;AAiBE;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;AAfJ;AAiBI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AAfN;;AAoBA;EACE,aAAA;EACA,QAAA;AAjBF;AAmBE;EACE,SAAA;AAjBJ;AAoBE;EACE,yBAAA;AAlBJ;AAoBI;EACE,yBAAA;AAlBN;;AAuBA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AApBF;;AAuBA;EACE,aAAA;EACA,QAAA;AApBF;AAsBE;EACE,SAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;AApBJ;AAsBI;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AApBN;;AAyBA;EACE,aAAA;EACA,SAAA;EACA,yBAAA;AAtBF;;AAyBA;EACE,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;AAtBF;AAwBE;EACE,yBAAA;AAtBJ;AAyBE;EACE,yBAAA;EACA,mBAAA;AAvBJ;AA0BE;EACE,yBAAA;AAxBJ;AA0BI;EACE,yBAAA;AAxBN;AA4BE;EACE,yBAAA;AA1BJ;AA4BI;EACE,yBAAA;AA1BN;;AA+BA;EACE;IACE,aAAA;EA5BF;EA+BA;IACE,aAAA;EA7BF;EAiCE;IACE,iBAAA;EA/BJ;EAkCE;IACE,iBAAA;EAhCJ;EAoCA;IACE,sBAAA;IACA,uBAAA;EAlCF;EAqCA;IACE,SAAA;EAnCF;EAsCA;IACE,sBAAA;EApCF;EAsCE;IACE,WAAA;EApCJ;EAwCA;IACE,sBAAA;EAtCF;EAwCE;IACE,WAAA;EAtCJ;EA0CA;;;IAGE,iBAAA;IACA,kBAAA;IACA,kBAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;EAxCF;EA2CA;IACE,eAAA;IACA,WAAA;EAzCF;EA6CE;IACE,iBAAA;EA3CJ;EA+CA;IACE,sBAAA;EA7CF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  padding: 20px;\n  background-color: #f5f5f5;\n}\n\n.buttonGroup {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 24px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n\n.createList,\n.createPrivateList {\n  padding: 12px 24px;\n  border-radius: 8px;\n  border: none;\n  background-color: #007bff;\n  color: white;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n\n  &:hover {\n    background-color: #0056b3;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);\n  }\n\n  &:active {\n    transform: translateY(0);\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n\n  &:disabled {\n    background-color: #cccccc;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n  }\n}\n\n.backButtonWrapper {\n  max-width: 1200px;\n  width: 100%;\n  margin: 0 auto 20px;\n}\n\n.backButton {\n  padding: 12px 24px;\n  border-radius: 8px;\n  border: none;\n  background-color: #6c757d;\n  color: white;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 500;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  width: auto;\n\n  &:hover {\n    background-color: #5a6268;\n    transform: translateY(-1px);\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);\n  }\n\n  &:active {\n    transform: translateY(0);\n  }\n}\n\n.content {\n  flex: 1;\n  width: 100%;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n  width: 100%;\n  height: 100%;\n\n  @media (max-width: 600px) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.card {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-height: 140px;\n  border: 1px solid #eaeaea;\n\n  &:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n}\n\n.userName {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #333;\n}\n\n.wishlistName {\n  font-size: 1rem;\n  color: #666;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.itemCount {\n  margin-top: auto;\n  color: #007bff;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.privateIcon {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  font-size: 1.1rem;\n  color: #666;\n}\n\n// Utility classes\n.row {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n  word-break: break-all;\n}\n\n.column {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  overflow: auto;\n  width: 100%;\n}\n\n.shareButtonColumn {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: auto;\n}\n\n.shareButtonRow {\n  display: flex;\n  gap: 12px;\n}\n\n.input {\n  display: flex;\n}\n\n.selectedWishlist {\n  background: white;\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  min-height: calc(100vh - 140px);\n  display: flex;\n  flex-direction: column;\n}\n\n.wishlistHeader {\n  margin-bottom: 24px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #eaeaea;\n\n  h2 {\n    font-size: 1.75rem;\n    color: #333;\n    margin: 0;\n    font-weight: 600;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    .privateIcon {\n      font-size: 1.2rem;\n      color: #666;\n    }\n  }\n\n  h3 {\n    font-size: 1.25rem;\n    color: #666;\n    margin: 8px 0 0 0;\n    font-weight: normal;\n  }\n}\n\n.wishList {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.wishItems {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.wishItem {\n  background: #f8f9fa;\n  border-radius: 8px;\n  padding: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 12px;\n  transition: background-color 0.2s ease;\n\n  &:hover {\n    background: #f0f0f0;\n  }\n\n  .wishText {\n    flex: 1;\n    word-break: break-word;\n    overflow-wrap: break-word;\n    hyphens: auto;\n  }\n}\n\n.itemActions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-shrink: 0;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: stretch;\n    width: 100%;\n  }\n}\n\n.orderButtons {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n\n  @media (max-width: 768px) {\n    justify-content: flex-end;\n  }\n}\n\n.orderButton {\n  padding: 4px 8px;\n  min-width: 36px;\n  background-color: #6c757d;\n\n  &:hover:not(:disabled) {\n    background-color: #5a6268;\n  }\n\n  &:disabled {\n    opacity: 0.5;\n  }\n}\n\n.orderEditForm {\n  display: flex;\n  align-items: center;\n  margin-left: 5px;\n}\n\n.orderInput {\n  width: 60px;\n  padding: 4px 8px;\n  margin-right: 4px;\n  font-size: 14px;\n  border: 1px solid #ced4da;\n  border-radius: 4px;\n\n  &:focus {\n    outline: none;\n    border-color: #007bff;\n    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n  }\n}\n\n.orderEditButton {\n  padding: 4px 8px;\n  margin-right: 8px;\n  font-size: 14px;\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n\n  &:hover:not(:disabled) {\n    background-color: #0056b3;\n  }\n\n  &:disabled {\n    opacity: 0.7;\n  }\n}\n\n.smallButton {\n  padding: 4px 8px;\n  margin: 0 2px;\n  font-size: 14px;\n  min-width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n\n  &:first-of-type {\n    background-color: #28a745;\n\n    &:hover:not(:disabled) {\n      background-color: #218838;\n    }\n  }\n\n  &:last-of-type {\n    background-color: #dc3545;\n\n    &:hover:not(:disabled) {\n      background-color: #c82333;\n    }\n  }\n}\n\n.editButton {\n  background-color: #ffc107;\n  color: #212529;\n\n  &:hover:not(:disabled) {\n    background-color: #e0a800;\n  }\n}\n\n.editWishForm {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n\n  input {\n    padding: 8px 12px;\n    border: 1px solid #ced4da;\n    border-radius: 6px;\n    font-size: 1rem;\n    width: 100%;\n\n    &:focus {\n      outline: none;\n      border-color: #007bff;\n      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n    }\n  }\n}\n\n.editActions {\n  display: flex;\n  gap: 8px;\n\n  button {\n    flex: 1;\n  }\n\n  .cancelButton {\n    background-color: #6c757d;\n\n    &:hover:not(:disabled) {\n      background-color: #5a6268;\n    }\n  }\n}\n\n.actionButtons {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.addWishForm {\n  display: flex;\n  gap: 8px;\n\n  input {\n    flex: 1;\n    padding: 12px;\n    border: 1px solid #ced4da;\n    border-radius: 6px;\n    font-size: 1rem;\n\n    &:focus {\n      outline: none;\n      border-color: #007bff;\n      box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n    }\n  }\n}\n\n.listActions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\nbutton {\n  padding: 8px 16px;\n  border-radius: 6px;\n  border: none;\n  background-color: #007bff;\n  color: white;\n  cursor: pointer;\n  font-size: 0.875rem;\n  transition: all 0.2s ease;\n\n  &:hover:not(:disabled) {\n    background-color: #0056b3;\n  }\n\n  &:disabled {\n    background-color: #cccccc;\n    cursor: not-allowed;\n  }\n\n  &.deleteButton {\n    background-color: #dc3545;\n\n    &:hover:not(:disabled) {\n      background-color: #c82333;\n    }\n  }\n\n  &.shareButton {\n    background-color: #28a745;\n\n    &:hover:not(:disabled) {\n      background-color: #218838;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n  }\n\n  .selectedWishlist {\n    padding: 16px;\n  }\n\n  .wishlistHeader {\n    h2 {\n      font-size: 1.5rem;\n    }\n\n    h3 {\n      font-size: 1.1rem;\n    }\n  }\n\n  .wishItem {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .actionButtons {\n    gap: 12px;\n  }\n\n  .addWishForm {\n    flex-direction: column;\n\n    input {\n      width: 100%;\n    }\n  }\n\n  .listActions {\n    flex-direction: column;\n\n    button {\n      width: 100%;\n    }\n  }\n\n  .createList,\n  .createPrivateList,\n  .backButton {\n    font-size: 0.9rem;\n    padding: 10px 16px;\n    text-align: center;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .itemActions {\n    margin-top: 8px;\n    width: 100%;\n  }\n\n  .editWishForm {\n    input {\n      font-size: 0.9rem;\n    }\n  }\n\n  .editActions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Wishlists_container__TzVNU`,
	"buttonGroup": `Wishlists_buttonGroup__ldBeE`,
	"createList": `Wishlists_createList__zpegs`,
	"createPrivateList": `Wishlists_createPrivateList__-dxuN`,
	"backButtonWrapper": `Wishlists_backButtonWrapper__BhrAs`,
	"backButton": `Wishlists_backButton__IK4c+`,
	"content": `Wishlists_content__tTy8l`,
	"grid": `Wishlists_grid__hkD0k`,
	"card": `Wishlists_card__xX3Kq`,
	"userName": `Wishlists_userName__hNF3c`,
	"wishlistName": `Wishlists_wishlistName__ap95c`,
	"itemCount": `Wishlists_itemCount__1qt69`,
	"privateIcon": `Wishlists_privateIcon__7Xne3`,
	"row": `Wishlists_row__9DIiR`,
	"column": `Wishlists_column__uHLh1`,
	"shareButtonColumn": `Wishlists_shareButtonColumn__TmA65`,
	"shareButtonRow": `Wishlists_shareButtonRow__bp0Mh`,
	"input": `Wishlists_input__xYeLQ`,
	"selectedWishlist": `Wishlists_selectedWishlist__snpE2`,
	"wishlistHeader": `Wishlists_wishlistHeader__Ya9lc`,
	"wishList": `Wishlists_wishList__yfVvy`,
	"wishItems": `Wishlists_wishItems__X-jeJ`,
	"wishItem": `Wishlists_wishItem__ssrpY`,
	"wishText": `Wishlists_wishText__oFtyh`,
	"itemActions": `Wishlists_itemActions__SOhOD`,
	"orderButtons": `Wishlists_orderButtons__C2RR+`,
	"orderButton": `Wishlists_orderButton__yT9qW`,
	"orderEditForm": `Wishlists_orderEditForm__MgfaC`,
	"orderInput": `Wishlists_orderInput__PHbaE`,
	"orderEditButton": `Wishlists_orderEditButton__fSrK4`,
	"smallButton": `Wishlists_smallButton__910or`,
	"editButton": `Wishlists_editButton__LqdA8`,
	"editWishForm": `Wishlists_editWishForm__bJwMs`,
	"editActions": `Wishlists_editActions__XGMWm`,
	"cancelButton": `Wishlists_cancelButton__3D0hX`,
	"actionButtons": `Wishlists_actionButtons__tk+xE`,
	"addWishForm": `Wishlists_addWishForm__UdbrY`,
	"listActions": `Wishlists_listActions__h1ZpU`,
	"deleteButton": `Wishlists_deleteButton__UfvQo`,
	"shareButton": `Wishlists_shareButton__ovAMN`
};
export default ___CSS_LOADER_EXPORT___;
